import { InfiniteData } from '@tanstack/react-query'

import { RequestReturnType } from '@/api/models/notifications/lib/notifications.types'

const notificationHelpersById = {
  updateInfiniteReadStatus(
    oldData:
      | InfiniteData<{ page: number; response: RequestReturnType }>
      | undefined,
    readNotification: { id: string }
  ) {
    if (!oldData) {
      return oldData
    }

    const newData = oldData.pages.map(page => ({
      ...page,
      response: {
        ...page.response,
        data: {
          ...page.response.data,
          data:
            page.response.data.data?.map(item =>
              item.id === readNotification.id ? { ...item, isRead: true } : item
            ) || []
        }
      }
    }))

    return {
      ...oldData,
      pages: newData
    }
  },

  updateFirstPageReadStatus(
    oldData: RequestReturnType | undefined,
    readNotification: { id: string }
  ) {
    if (!oldData) {
      return oldData
    }

    return {
      ...oldData,
      data: {
        ...oldData.data,
        data:
          oldData.data.data?.map(item =>
            item.id === readNotification.id ? { ...item, isRead: true } : item
          ) || []
      }
    }
  }
}

export { notificationHelpersById }
